import { render } from "./MarketingServicesView.vue?vue&type=template&id=daa58562"
import script from "./MarketingServicesView.vue?vue&type=script&lang=js"
export * from "./MarketingServicesView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__